function tokenizeText(text) {
    return String(text || "").match(/\s+|[^\s]+/g) || [];
}

function buildLcsTable(leftTokens, rightTokens) {
    const rows = leftTokens.length + 1;
    const cols = rightTokens.length + 1;
    const table = Array.from({ length: rows }, () => Array(cols).fill(0));

    for (let row = leftTokens.length - 1; row >= 0; row -= 1) {
        for (let col = rightTokens.length - 1; col >= 0; col -= 1) {
            if (leftTokens[row] === rightTokens[col]) {
                table[row][col] = table[row + 1][col + 1] + 1;
            } else {
                table[row][col] = Math.max(table[row + 1][col], table[row][col + 1]);
            }
        }
    }

    return table;
}

export function buildInlineDiffSegments(previousText, nextText) {
    const leftTokens = tokenizeText(previousText);
    const rightTokens = tokenizeText(nextText);
    const table = buildLcsTable(leftTokens, rightTokens);
    const segments = [];

    let row = 0;
    let col = 0;

    const pushSegment = (type, value) => {
        if (!value) {
            return;
        }

        const last = segments[segments.length - 1];
        if (last && last.type === type) {
            last.value += value;
            return;
        }

        segments.push({ type, value });
    };

    while (row < leftTokens.length && col < rightTokens.length) {
        if (leftTokens[row] === rightTokens[col]) {
            pushSegment("equal", leftTokens[row]);
            row += 1;
            col += 1;
            continue;
        }

        if (table[row + 1][col] >= table[row][col + 1]) {
            pushSegment("remove", leftTokens[row]);
            row += 1;
            continue;
        }

        pushSegment("add", rightTokens[col]);
        col += 1;
    }

    while (row < leftTokens.length) {
        pushSegment("remove", leftTokens[row]);
        row += 1;
    }

    while (col < rightTokens.length) {
        pushSegment("add", rightTokens[col]);
        col += 1;
    }

    return segments;
}
